import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";

export type CertificationPdfScope = "investor" | "company";

export interface UploadCertificationPdfsPayload {
  scope: CertificationPdfScope;
  termsId: number;
  pdfFiles: File[];
}

export const useUploadCertificationPdfs = (
  options?: UseMutationOptions<
    unknown,
    unknown,
    UploadCertificationPdfsPayload,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: UploadCertificationPdfsPayload) => {
      const formData = new FormData();
      data.pdfFiles.forEach((file) => {
        formData.append("PdfFiles", file);
      });

      const path =
        data.scope === "company"
          ? `/MuslimInvestProfile/CompanyTerms/${data.termsId}/UploadCertificationPdfs`
          : `/MuslimInvestProfile/Terms/${data.termsId}/UploadCertificationPdfs`;

      return axiosInstance
        .post(getAPIURL(path), formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
    },
  });
};
